import { render, staticRenderFns } from "./potencial-lubrificantes.vue?vue&type=template&id=76a63018&scoped=true&"
import script from "./potencial-lubrificantes.vue?vue&type=script&lang=js&"
export * from "./potencial-lubrificantes.vue?vue&type=script&lang=js&"
import style0 from "./potencial-lubrificantes.vue?vue&type=style&index=0&id=76a63018&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a63018",
  null
  
)

export default component.exports